import Cookies from 'universal-cookie';
import type { TTokenRes } from 'api/swagger';

const CRM_REFRESH_TOKEN_COOKIE = 'log_rt';
const CRM_ACCESS_TOKEN_COOKIE = 'log_at';
const CLIENT_REFRESH_TOKEN_COOKIE = 'user_rt';
const CLIENT_ACCESS_TOKEN_COOKIE = 'user_at';
const REDUCE_EXPIRE_TIME = 45; // in seconds

const REFRESH_TOKEN_COOKIE =
  import.meta.env.VITE_APP_TYPE === 'crm' ? CRM_REFRESH_TOKEN_COOKIE : CLIENT_REFRESH_TOKEN_COOKIE;
const ACCESS_TOKEN_COOKIE =
  import.meta.env.VITE_APP_TYPE === 'crm' ? CRM_ACCESS_TOKEN_COOKIE : CLIENT_ACCESS_TOKEN_COOKIE;

const cookies = new Cookies(null, { path: '/' });

export const saveTokens = (tokens: TTokenRes) => {
  cookies.set(REFRESH_TOKEN_COOKIE, tokens.refreshToken, { maxAge: tokens.refreshExpiresIn });
  saveAccessToken(tokens.accessToken, tokens.expiresIn);
};

export const saveAccessToken = (accessToken: string, expiresIn: number) => {
  const maxAge = expiresIn - REDUCE_EXPIRE_TIME;
  cookies.set(ACCESS_TOKEN_COOKIE, accessToken, { maxAge });
};

export const getRefreshToken = () => cookies.get(REFRESH_TOKEN_COOKIE);
export const getAccessToken = () => cookies.get(ACCESS_TOKEN_COOKIE);
export const cleanTokens = () => {
  cookies.remove(REFRESH_TOKEN_COOKIE);
  cookies.remove(ACCESS_TOKEN_COOKIE);
};
